/* Prescription route gate for prescription-only (LM-tagged) products — ported from the live CFS theme.
   Locks Add to basket (class + aria-disabled) and blocks the click/submit until a route is complete. */
(() => {
  if (customElements.get('cfs-prescription')) return;
  const ADD_SELECTOR = 'button[name="add"], button[type="submit"], .shopify-payment-button';
  class CfsPrescription extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form') || document.getElementById(this.dataset.formId);
      if (!this.form) return;
      this.status = this.querySelector('[data-rx-status]');
      this.statusText = this.status ? (this.status.querySelector('span') || this.status) : null;
      this.update = this.update.bind(this); this.guard = this.guard.bind(this);
      this.addEventListener('change', this.update); this.addEventListener('input', this.update);
      document.addEventListener('submit', this.guard, true); document.addEventListener('click', this.guard, true);
      this.observer = new MutationObserver(() => this.markButtons());
      this.observer.observe(this.form, { childList: true, subtree: true });
      this.update();
    }
    disconnectedCallback() {
      document.removeEventListener('submit', this.guard, true); document.removeEventListener('click', this.guard, true);
      if (this.observer) this.observer.disconnect();
    }
    route() { const c = this.querySelector('input[type="radio"]:checked'); return c ? c.value : ''; }
    valid() {
      const route = this.route(); if (!route) return false;
      const panel = this.querySelector(`[data-rx-panel="${route}"]`); if (!panel) return false;
      return Array.from(panel.querySelectorAll('input')).every((i) => i.type === 'checkbox' ? i.checked : i.value.trim().length >= 3);
    }
    update() {
      const route = this.route();
      this.querySelectorAll('[data-rx-panel]').forEach((p) => { const on = p.dataset.rxPanel === route; p.hidden = !on; p.querySelectorAll('input').forEach((i) => { i.disabled = !on; }); });
      if (this.statusText) {
        this.statusText.textContent = !route ? this.dataset.msgChoose : !this.valid() ? (route === 'VetPal' ? this.dataset.msgVetpal : this.dataset.msgNumber) : this.dataset.msgOk;
        this.classList.toggle('is-complete', !!route && this.valid());
      }
      this.markButtons();
    }
    buttons() { const id = this.form.id; return Array.from(this.form.querySelectorAll(ADD_SELECTOR)).concat(id ? Array.from(document.querySelectorAll(`button[form="${id}"]`)) : []); }
    markButtons() {
      const lock = !this.valid();
      this.buttons().forEach((b) => { b.classList.toggle('cfs-rx-locked', lock); if (b.classList.contains('shopify-payment-button')) { b.hidden = true; return; } if (lock) b.setAttribute('aria-disabled', 'true'); else b.removeAttribute('aria-disabled'); });
    }
    guard(e) {
      const isSubmit = e.type === 'submit', t = isSubmit ? e.target : e.target.closest(ADD_SELECTOR); if (!t) return;
      const form = isSubmit ? t : (t.form || t.closest('form')); if (form !== this.form || this.valid()) return;
      e.preventDefault(); e.stopImmediatePropagation(); this.update();
      const next = this.route() ? this.querySelector('[data-rx-panel]:not([hidden]) input:not([disabled])') : this.querySelector('input[type="radio"]');
      if (next) next.focus();
    }
  }
  customElements.define('cfs-prescription', CfsPrescription);
})();
